export const createGaugeOptions = (val, max, showHamburger = false) => {
  if(!val) val = 0
  if(!max) max = 100


  const constrainedValue = Math.min(Math.max(val, 0), max)
  const valGreatedThanMax = val > max 

  const options = {
    chart: {
      type: 'gauge',
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: '80%'
    },

    title: {
      text: null
    },

    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ['50%', '75%'],
      size: '110%'
    },

    yAxis: {
      min: 0,
      max: max || 200,
      tickPixelInterval: 1,
      tickPosition: 'inside',
      tickColor:  '#FFFFFF',
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
        enabled: false
      },
      lineWidth: 0,
      plotBands: [{
        from: 0,
        to: max/3,
        color: '#55BF3B', 
        thickness: 10,
      }, {
        from: max/3,
        to: 2*max/3,
        color: '#DDDF0D',
        thickness: 10,
      }, {
        from: 2*max/3,
        to: max,
        color: '#DF5353', 
        thickness: 10
      }]
    },

    series: [{
      name: '',
      data: [constrainedValue],
      dataLabels: {
        format: `${val} (Max: ${max})`,
        borderWidth: 0,
        color:  valGreatedThanMax ? '#FF0000' : '#333333',
        border: '0px',
        style: {
          fontSize: '12px',
          textOutline: 'none'
        },
      },
      dial: {
        radius: '70%',
        backgroundColor: 'black',
        baseWidth: 8,
        baseLength: '0%',
        rearLength: '0%'
      },
      pivot: {
        backgroundColor: 'black',
        radius: 4
      }
    }],
    credits: {
      enabled: false
    },
    exporting: {
      enabled: showHamburger
    }
  };

  return options
};